declare var window: any

import microuniversoApi from 'app/api/microuniversoApi'
import { removerBreadcrumb2 } from 'app/components/breadcrumb2/breadcrumb2Utils'
import { SolicitarSenhaContainer } from 'app/components/senha/SolicitarSenhaContainer'
import { SimuladorPrecoContainerDialog } from 'app/components/simulacao-preco/SimuladorPrecoContainerDialog'
import global from 'globalMU'
import React from 'react'
import { SimularPrecoItemOrcamentoController } from './simularPrecoItemOrcamentoController'
const { PesquisarEstoqueController } = require('../produtos/pesquisarEstoqueController')
const { AgregadosController } = require('./agregadosController')
const { SimilaresController } = require('../produtos/similaresController')
const { OfertasProdutoController } = require('../produtos/ofertasProdutoController')
const { UltimasComprasProdutoController } = require('./ultimasComprasProdutoController')
const { EditarPrecoTintaController } = require('./editarPrecoTintaController')
const { LotesProdutoConsultaController } = require('../produtos/lotesProdutoConsultaController')
const { LotesReservadosProdutoConsultaController } = require('../produtos/LotesReservadosProdutoConsultaController')
const { SugerirProdutoAgregadoController } = require('../produtos/sugerirProdutoAgregadoController')
const { PesquisarTributacaoController } = require('../produtos/pesquisarTributacaoController')
import { TratamentoMadeiraItemContainer } from 'app/components/madeira/TratamentoMadeiraItemContainer'
import globalMU from 'globalMU'
import { renderizarComponentReact } from 'app/components/renderizarOuRemoverComponentReact'
const { PesquisarMovimentacaoEstoqueController } = require('../produtos/PesquisarMovimentacaoEstoqueController')


const MenuConsultaProdutosController = ObjectBase.extend({
    show: function () {
        this.atacharEventos();
        $("#menu-consulta-produtos").show();
    },

    hide: function () {
        $("#menu-consulta-produtos").hide();
        $("#menu-sub-consulta-produtos").hide();
    },

    esconderContainers: function () {
        $("[container]").hide();

        removerBreadcrumb2()
    },
    atacharEventos: function () {
        $("#simulacao-preco-item-orcamento").unbind();
        $("#simulacao-preco-item-orcamento").click($.proxy(this.simularPrecoItemOrcamentoReact, this)); // FNX-5311

        $("#estoque-item-menu").unbind();
        $("#estoque-item-menu").click($.proxy(this.pesquisarEstoque, this));

        $("#estoque-item-menu-react").unbind();
        $("#estoque-item-menu-react").click($.proxy(this.pesquisarEstoqueReact, this));

        $("#agregados-item-menu").unbind();
        $("#agregados-item-menu").click($.proxy(this.pesquisarAgregados, this));

        $("#agregados-item-menu-react").unbind();
        $("#agregados-item-menu-react").click($.proxy(this.pesquisarAgregadosReact, this));

        $("#similares-item-menu").unbind();
        $("#similares-item-menu").click($.proxy(this.pesquisarSimilares, this));

        $("#similares-item-menu-react").unbind();
        $("#similares-item-menu-react").click($.proxy(this.pesquisarSimilaresReact, this));

        $("#ofertas-item-menu").unbind();
        $("#ofertas-item-menu").click($.proxy(this.pesquisarOfertasProduto, this));

        $("#ofertas-item-menu-react").unbind();
        $("#ofertas-item-menu-react").click($.proxy(this.pesquisarOfertasProdutoReact, this));

        $("#lotes-produto-consulta-item-menu").unbind();
        $("#lotes-produto-consulta-item-menu").click($.proxy(this.pesquisarLotesProdutoConsulta, this));

        $("#lotes-produto-consulta-item-menu-react").unbind();
        $("#lotes-produto-consulta-item-menu-react").click($.proxy(this.pesquisarLotesProdutoConsultaReact, this));

        $("#lotes-reservados-produto-consulta-item-menu").unbind();
        $("#lotes-reservados-produto-consulta-item-menu").click($.proxy(this.pesquisarLotesReservadosProdutoConsulta, this));

        $("#lotes-reservados-produto-consulta-item-menu-react").unbind();
        $("#lotes-reservados-produto-consulta-item-menu-react").click($.proxy(this.pesquisarLotesReservadosProdutoConsultaReact, this));

        $("#sugerir-produtos-agregados-item-menu").unbind();
        $("#sugerir-produtos-agregados-item-menu").click($.proxy(this.sugerirProdutosAgregados, this));

        $("#sugerir-produtos-agregados-item-menu-react").unbind();
        $("#sugerir-produtos-agregados-item-menu-react").click($.proxy(this.sugerirProdutosAgregadosReact, this));

        $("#tributacao-produto-item-menu").unbind();
        $("#tributacao-produto-item-menu").click($.proxy(this.consultarTributacao, this));

        $("#tributacao-produto-item-menu-react").unbind();
        $("#tributacao-produto-item-menu-react").click($.proxy(this.consultarTributacaoReact, this));

        $("#movimentacao-estoque-produto-item-menu").unbind();
        $("#movimentacao-estoque-produto-item-menu").click($.proxy(this.consultarMovimentacaoEstoque, this));

        $("#movimentacao-estoque-produto-item-menu-react").unbind();
        $("#movimentacao-estoque-produto-item-menu-react").click($.proxy(this.consultarMovimentacaoEstoqueReact, this));

        $("#ultimas-compras-produto").unbind();
        $("#ultimas-compras-produto").click($.proxy(this.ultimasComprasProdutos, this));

        $("#ultimas-compras-produto-react").unbind();
        $("#ultimas-compras-produto-react").click($.proxy(this.ultimasComprasProdutosReact, this));

        this.obterModel();
        if (this.model.attributes.CodigoCorTinta > 0) {
            $("#tinta").parent().show();
        }
        else {
            $("#tinta").parent().hide();
        }
        $("#tinta").unbind();
        $("#tinta").click($.proxy(this.tinta, this));


        if (this.model.attributes.CodigoCorTinta > 0) {
            $("#tinta-react").parent().show();
        }
        else {
            $("#tinta-react").parent().hide();
        }

        $("#tinta-react").unbind();
        $("#tinta-react").click($.proxy(this.tintaReact, this));


        $("#medidas-madeira").unbind();
        $("#medidas-madeira").click($.proxy(this.medidasMadeira, this));

        if (!this.model || !this.model.attributes.Identificador) { // FNX-5311 -- é a pesquisa de produtos, nao tem simulacao
            $("#simulacao-preco-item-orcamento").parent().hide(); // FNX-5311
        }
        else {
            $("#simulacao-preco-item-orcamento").parent().show();
        }

        $("input").on('focus', function () { $(this).select(); });
    },

    obterModel: function () {
        if (this.obterModelCallback) {
            this.model = this.obterModelCallback();
        }

    },

    // TODO: remover em breve
    simularPrecoItemOrcamento: function () { // FNX-5311

        this.obterModel();

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de simular o preço.");
            return;
        }
        
        this.simularPrecoItemOrcamentoController = this.controller.showView({
            region: {
                name: "simularPrecoItemOrcamentoRegion",
                selector: "#simular-preco-item-orcamento-container"
            },
            controller: {
                type: SimularPrecoItemOrcamentoController,
                args: {
                    identificadorOrcamento: this.model.attributes.IdentificadorOrcamento,
                    identificador: this.model.attributes.Identificador,
                    model: this.model
                }
            },
            success: function () {
                limparSelecaoEstoqueProduto();
                $("menu-sub-consulta-produtos").show();
            }
        });

        if ($("#pesquisar-estoque-produto-region").is(":visible") ||
            $("[regionname=estoqueProdutoViewRegion]").is(":visible")) {
            $("#mostrar-historico-filtro").hide();
        }

    },
/* 457575
    simularPrecoItemOrcamentoReact: function () {

        const simuladorPrecoContainerDialog = <SimuladorPrecoContainerDialog
            identificadorOrcamento={this.model.attributes.IdentificadorOrcamento}
            identificadorItem={this.model.attributes.Identificador}
            orcamentoVenda={this.model.attributes.TipoOrcamentoDescricao == "Venda"}
            somenteLeitura={false}
            onAplicar={async () => {
                const itensTotaisOrcamento = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(this.model.attributes.IdentificadorOrcamento)
                window.orcamentoController.model.atualizar(itensTotaisOrcamento)
                window.orcamentoController.renderizarViewItemVenda()
            }}
            onCancelar={() => window.orcamentoController.renderizarViewItemVenda()} />

        const solicitarSenhaContainer = <SolicitarSenhaContainer
            onRemover={() => {}}
            onVoltar={() => {}}
            passos={null}
            exibirBotaoVoltar={true}
            onSenhaValidada={senhaValida => {
                if (senhaValida) renderizarComponentReact(simuladorPrecoContainerDialog, "conteudo-pagina", false)
            }}
            dicaPermissao={"Permissao: [Libera simulação de pesquisa de preços no orçamento]"} 
            permissao={"TIPO_LIBERACAO_LIBERASIMULACAOPESQUISAORC"} />

        renderizarComponentReact(solicitarSenhaContainer, "conteudo-pagina", false)
    },
*/
    pesquisarEstoque: function () {

        this.obterModel();

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar o estoque.");
            return;
        }

        this.pesquisarEstoqueItemController = this.controller.showView({
            region: {
                name: "estoqueProdutoRegion",
                selector: "#pesquisar-estoque-produto-container"
            },
            controller: {
                type: PesquisarEstoqueController,
                args: {
                    model: this.model
                }
            },
            success: function () {
                limparSelecaoEstoqueProduto();
                $("menu-sub-consulta-produtos").show();
            }
        });

        if ($("#pesquisar-estoque-produto-region").is(":visible") ||
            $("[regionname=estoqueProdutoViewRegion]").is(":visible")) {
            $("#mostrar-historico-filtro").hide();
        }

    },

    pesquisarAgregados: function () {
        const itemOrcamentoController = window.orcamentoController.itemOrcamentoController

        this.obterModel();

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar os produtos agregados.");
            return;
        }

        //$('#tabela-itens-orcamento-region td.selecionavel').parents('tr').css('background-color', '');

        //this.controller.orcamentoController.model.get('ItensOrcamento').each(function (model) {
        //    model.set('selecionado', false);
        //});


        this.agregadosController = this.controller.showView({
            region: {
                name: "agregadosControllerRegion",
                selector: "#pesquisar-agregados-produto-container"
            },
            controller: {
                type: AgregadosController,
                args: {
                    model: this.model,
                    modoInclusao: this.controller.modoInclusao,
                    adicionarProdutosCallback: $.proxy(this.adicionarProdutosCallback, itemOrcamentoController)
                }
            },
            success: function () {
                limparSelecaoEstoqueProduto();
                $("#menu-sub-consulta-produtos").hide();

                if (this.pesquisarEstoqueItemController != null)
                    this.pesquisarEstoqueItemController.hide();

                if (this.similaresController != null)
                    this.similaresController.hide();
            }
        });

        if ($("#pesquisar-estoque-produto-region").is(":visible") ||
            $("[regionname=estoqueProdutoViewRegion]").is(":visible")) {
            $("#mostrar-historico-filtro").hide();
        }

    },    
    pesquisarSimilares: function () {

        this.obterModel();

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar os produtos similares.");
            return;
        }

        this.similaresController = this.controller.showView({
            region: {
                name: "similaresControllerRegion",
                selector: "#pesquisar-similares-produto-container"
            },
            controller: {
                type: SimilaresController,
                args: {
                    model: this.model,
                    modoInclusao: this.controller.modoInclusao,
                    adicionarProdutosCallback: $.proxy(this.adicionarProdutosCallback, this)
                }
            },
            success: function () {
                limparSelecaoEstoqueProduto();
                $("#menu-sub-consulta-produtos").hide();

                if (this.agregadosController != null)
                    this.agregadosController.hide();

                if (this.pesquisarEstoqueItemController != null)
                    this.pesquisarEstoqueItemController.hide();
            }
        });

        if ($("#pesquisar-estoque-produto-region").is(":visible") ||
            $("[regionname=estoqueProdutoViewRegion]").is(":visible")) {
            $("#mostrar-historico-filtro").hide();
        }
    },
    pesquisarOfertasProduto: function () {

        this.obterModel();

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar as ofertas.");
            return;
        }

        this.ofertasProdutoController = this.controller.showView({
            region: {
                name: "ofertasProdutoControllerRegion",
                selector: "#ofertas-produto-container"
            },
            controller: {
                type: OfertasProdutoController,
                args: {
                    orcamento: this.orcamento,
                    produto: this.model
                }
            },
            success: function () {
                this.limparSelecaoEstoqueProduto();
                $("#menu-sub-consulta-produtos").hide();

                if (this.agregadosController != null)
                    this.agregadosController.hide();

                if (this.pesquisarEstoqueItemController != null)
                    this.pesquisarEstoqueItemController.hide();
            }
        });

    },
    ultimasComprasProdutos: function () {

        this.obterModel();

        if (this.orcamento.get("CodigoCliente") <= 7) {
            global.showInfoMessage("Selecione um cliente antes de consultar última compra.");
            return;
        }

        this.ultimasComprasProdutoController = this.controller.showView({
            region: {
                name: "ultimasComprasProdutoControllerRegion",
                selector: "#pesquisar-ultima-compra-region"
            },
            controller: {
                type: UltimasComprasProdutoController,
                args: {
                    orcamento: this.orcamento,
                    collection: this.model.get('Codigo') ? [this.model.get('Codigo')] : this.model.collection.map(function (x) { return x.get('Codigo'); }),
                    showModal: false
                }
            }
        })

    },

    tinta: function (e) {
        e.preventDefault();
        this.obterModel();
        console.log("this.model",this.model);

        this.editarPrecoTintaController = this.controller.showView({
            region: {
                name: "editarPrecoTintaRegion",
                selector: "#editar-preco-tinta-region"
            },
            controller: {
                type: EditarPrecoTintaController,
                args: {
                    itemOrcamento: this.model,
                    finalizarCallback: $.proxy(this.finalizarEdicaoPrecoTinta, this)

                }
            }
        });
    },

    

    medidasMadeira: function (e) {
        e.preventDefault();
        this.obterModel();
        const tratamentoMadeiraContainer = <TratamentoMadeiraItemContainer item={this.model.attributes}
            somenteLeitura={true}
            onOk={() => null}
            onClose={() => null} />

        this.model.attributes.Madeira ?
            renderizarComponentReact(tratamentoMadeiraContainer, "conteudo-pagina", false)
            : globalMU.showWarnMessage("Produto não tem tratamento de madeira!")
    },

    finalizarEdicaoPrecoTinta: function () {

        this.editarPrecoTintaController.hide();
        this.controller.show();

    },

    limparSelecaoEstoqueProduto: function () {
        $("#lista-estoque-produto-container tr", this.$el)
            .each(function () {
                $(this).css("background-color", "");
            });
    },

    pesquisarLotesProdutoConsulta: function () {
        this.obterModel();
        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar as lotes do produto.");
            return;
        }
        this.LotesProdutoConsultaController = this.controller.showView({
            region: {
                name: "LotesProdutoConsultaControllerRegion",
                selector: "#lotes-produto-consulta-container"
            },
            controller: {
                type: LotesProdutoConsultaController,
                args: {
                    produto: this.model
                }
            },
        });

    },

    pesquisarLotesReservadosProdutoConsulta: function () {
        this.obterModel();
        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar as lotes reservados do produto.");
            return;
        }
        this.LotesReservadosProdutoConsultaController = this.controller.showView({
            region: {
                name: "LotesReservadosProdutoControllerRegion",
                selector: "#lotes-reservador-produto-consulta-container"
            },
            controller: {
                type: LotesReservadosProdutoConsultaController,
                args: {
                    produto: this.model
                }
            },
        });

    },


    sugerirProdutosAgregados: function () {

        this.obterModel();

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de solicitar consulta.");
            return;
        }

        this.sugerirProdutoAgregadoController = this.controller.showView({
            region: {
                name: "sugerirProdutoAgregadoRegion",
                selector: "#sugerir-produto-agregado-region"
            },
            controller: {
                type: SugerirProdutoAgregadoController,
                args: {
                    orcamento: this.orcamento,
                    itemOrcamento: this.model,
                    modoInclusao: this.controller.modoInclusao,
                    adicionarProdutosCallback: $.proxy(this.adicionarProdutosCallback, this)
                }
            },
            success: function () {
                limparSelecaoEstoqueProduto();
                $("#menu-sub-consulta-produtos").hide();

                if (this.agregadosController != null)
                    this.agregadosController.hide();

                if (this.pesquisarEstoqueItemController != null)
                    this.pesquisarEstoqueItemController.hide();

                if (this.sugerirProdutoAgregadoController != null)
                    this.sugerirProdutoAgregadoController.hide();
            }
        });

        if ($("#pesquisar-estoque-produto-region").is(":visible") ||
            $("[regionname=estoqueProdutoViewRegion]").is(":visible")) {
            $("#mostrar-historico-filtro").hide();
        }

    },

    consultarTributacao: function () {

        this.obterModel();

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar a tributação.");
            return;
        }

        // O selector pesquisar-tributacao-produto-container deve ser especificado no html onde será redenrizado, neste caso _itensOrcamento.cshtml e _Pesquisa.cshtml
        this.tributacaoController = this.controller.showView({
            region: {
                name: "tributacaoProdutoControllerRegion",
                selector: "#pesquisar-tributacao-produto-container"
            },
            controller: {
                type: PesquisarTributacaoController,
                args: {
                    orcamento: this.orcamento,
                    model: this.model
                }
            },
            success: function () {
                limparSelecaoEstoqueProduto();
                $("#menu-sub-consulta-produtos").hide();

                if (this.agregadosController != null)
                    this.agregadosController.hide();

                if (this.pesquisarEstoqueItemController != null)
                    this.pesquisarEstoqueItemController.hide();
            }
        });
    },
    consultarMovimentacaoEstoque: function () {
        this.obterModel();

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar a movimentação de estoque.");
            return;
        }

        this.pesquisarMovimentacaoEstoqueController = this.controller.showView({
            region: {
                name: "movimentacaoEstoqueProdutoControllerRegion",
                selector: "#pesquisar-movimentacao-estoque-produto-container"
            },
            controller: {
                type: PesquisarMovimentacaoEstoqueController,
                args: {
                    produto: this.model
                }
            }
        })
    }
});

window.MenuConsultaProdutosController = MenuConsultaProdutosController

export { MenuConsultaProdutosController }
